import Joi from "joi";
import { emailRegex } from "../../../utils/common";



export const createOwnershipSchema = 
  Joi.object({
    name: Joi.string()
      .min(3)
      .max(255)
      .required()
      .messages({
        "string.empty": "Name is required.",
        "string.required": "Name is required.",
        "string.min": "Name must be at least 3 characters.",
        "string.max": "Name must not exceed 255 characters.",
        "any.invalid": "Name is required.",

      }),

    phone: Joi.string()
      .pattern(/^[6-9]\d{9}$/)
      .required()
      .custom((value, helpers) => {
        if (!/^[6-9]\d{9}$/.test(value)) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .messages({
        "string.pattern.base": "Invalid phone number format.",
        "string.empty": "Phone number is required.",
        "string.required": "Phone number is required.",
        "any.invalid": "Invalid phone number format.",
      }),

    email: Joi.string().pattern(emailRegex)
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.pattern.base": "Invalid  email format",
        "string.base": "Email is required.",
        "string.required": "Email is required.",
        "string.invalid": "Email is required.",
        "string.empty": "Email is required.",
        "string.email": "Please provide a valid email address.",
      }),

    designation: Joi.string()
      .min(2)
      .max(100)
      // .required()
     .allow("")
      .messages({
        // "string.empty": "Designation is required.",
        "string.min": "Designation must be at least 2 characters.",
        "string.max": "Designation must not exceed 100 characters.",
      }),

    identity_no: Joi.string()
      .min(1)
      // .required()
     .allow("")

      .messages({
        "string.empty": "Identity number is required.",
        "string.min": "Identity number must be at least 1 character.",
      }),

    pan: Joi.string()
      .pattern(/^[A-Z]{5}[0-9]{4}[A-Z]$/)
      // .required()
     .allow("")

      .custom((value, helpers) => {
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .messages({
        "string.pattern.base": "PAN number must be in the format ABCTY1234D.",
        "string.empty": "PAN is required.",
        "any.invalid": "Invalid PAN format.",
      }),
  })

